import React, { useCallback } from 'react';

import { useEscapeKey } from '@src/corelib/hooks';

import { cn } from './utils';


/**
 * Shared right detail drawer per the .pen "Drawer" frames (520px panel over a
 * scrim, hairline left border, soft shadow). On mobile it becomes a
 * full-screen sheet (UX 3C). Closes on ESC and scrim click.
 *
 * `ref` forwards to the role="dialog" panel; `aria-labelledby` and any other
 * passed props spread onto that panel.
 */
const Drawer = React.forwardRef((props, ref) => {
  const { open, onClose, children, className, ...restProps } = props;

  useEscapeKey(useCallback(() => onClose?.(), [onClose]), open);

  if (!open) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-40">
      <button
        type="button"
        aria-label="Close"
        className="absolute inset-0 cursor-default bg-scrim"
        onClick={() => onClose?.()}
      />

      <div
        ref={ref}
        className={cn(
          'absolute inset-y-0 right-0 flex w-full flex-col bg-surface-1',
          'border-hairline shadow-drawer lg:w-[520px] lg:border-l',
          className,
        )}
        role="dialog"
        aria-modal="true"
        {...restProps}
      >
        {children}
      </div>
    </div>
  );
});

Drawer.displayName = 'Drawer';
export { Drawer };
export default Drawer;
